import React from 'react';

import { FeatureFlag } from 'app/api/services/site-configs/types';

import { useFeatureFlag } from 'app/lib/feature-flags';

import { AdultAge } from '../AdultAge';
import { AuthorizationBody, AuthorizationBodyWithFP } from '../AuthorizationModal/AuthorizationBody';
import { AuthorizationFooter } from '../AuthorizationModal/AuthorizationFooter';

export const Authorization = () => {
  const isFingerprint = useFeatureFlag(FeatureFlag.FINGERPRINT);

  return (
    <>
      {isFingerprint ? <AuthorizationBodyWithFP /> : <AuthorizationBody />}
      <AuthorizationFooter />
      <AdultAge />
    </>
  );
};
